import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateIntegrationsSettings } from './updateIntegrationsSettings';
import { IntegrationsConfigurationModel } from './types';
import { COMPANY_API_SETTINGS_MOCKED } from '@/env';
import { QUERY_KEY_SETTINGS_INTEGRATION } from '@/lib/api/constants';
import { toast } from '@/lib/toasts/api';

export function useMutationIntegrationsSettings(companyId: string) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (payload: IntegrationsConfigurationModel) => {
            if (COMPANY_API_SETTINGS_MOCKED) {
                return { message: "Success" }
            }
            const resp = await updateIntegrationsSettings({ companyId, payload })
            return resp
        },

        onError: (error) => {
            console.error('Error useMutationIntegrationsSettings:', error);
            toast.error({ text: 'Nie udało się zapisać konfiguracji.' });
        },

        onSuccess: () => {
            // Unieważniamy zamiast wpisywać lokalny payload do cache: zapisany
            // stan formularza nie musi być tym, co faktycznie zwróci serwer.
            queryClient.invalidateQueries({ queryKey: [QUERY_KEY_SETTINGS_INTEGRATION, companyId] })
            toast.success({ text: 'Konfiguracja została zapisana.' });
        },
    });
}
